/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1SerievideoId200,
  GetApiV1SerievideoId401,
  GetApiV1SerievideoId404,
  GetApiV1SerievideoId500,
  GetApiV1SerievideoIdPathParams,
  GetApiV1SerievideoIdQueryParams,
  GetApiV1SerievideoIdQueryResponse,
} from "../../types/serieVideoRegistroController/GetApiV1SerievideoId.ts";
import { serieVideoViewModelSchema } from "../serieVideoViewModelSchema.ts";

export const getApiV1SerievideoIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1SerievideoIdPathParams>;

export const getApiV1SerievideoIdQueryParamsSchema = z
  .object({
    serieId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1SerievideoIdQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1SerievideoId200Schema = z.lazy(
  () => serieVideoViewModelSchema,
) as unknown as ToZod<GetApiV1SerievideoId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1SerievideoId401Schema =
  z.any() as unknown as ToZod<GetApiV1SerievideoId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1SerievideoId404Schema =
  z.any() as unknown as ToZod<GetApiV1SerievideoId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1SerievideoId500Schema =
  z.any() as unknown as ToZod<GetApiV1SerievideoId500>;

export const getApiV1SerievideoIdQueryResponseSchema = z.lazy(
  () => getApiV1SerievideoId200Schema,
) as unknown as ToZod<GetApiV1SerievideoIdQueryResponse>;
